export const replaceEmptyStringsOnNull = (candidate) => Object.entries(candidate).reduce(
    (acc, [key, value]) => {
        acc[key] = value === "" ? null : value;
        return acc;
    },
    {},
)